














import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/components/UI/Modal.vue';
import store from '@/store';
import scriptLoad from '@/commons/scriptLoad';
import checkout from '@/store/modules/checkout';
import pickuppoint from '@/store/modules/pickuppoint';
import ui from '@/store/modules/ui';

@Component({
  components: {
    Modal,
  },
})
export default class StorePickupMethod extends Vue {
  private modalId = 'pickuppointModal';

  private mounted() {
    window.onShippyPointSelectionCallback = (pointData: any, pointId: any) => {
      const pickupPoint = {id: pointId, data: pointData};
      pickuppoint.savePickupPoint(pickupPoint);
      this.$emit('pickupPointSelected', pickupPoint);
      this.toggleModal(false);
    }
    const configs = store.state.options.carrier.pickuppoints;
    const attrs = {
      country: checkout.billingAddress.country_id,
      lang: store.state.options.locale,
      zip: checkout.billingAddress.postcode,
      city: checkout.billingAddress.city,
      key: configs.apikey,
      maps: '',
      callback: 'onShippyPointSelectionCallback'
    };
    const mountEl = document.getElementById('pickuppoint-widget');
    scriptLoad(configs.sdk, false, attrs, {appendToEl: mountEl, forceReload: true});
  }

  private destroyed() {
    const scripts = document.head.querySelectorAll('script');
    for (let i = scripts.length; i >= 0; i--){
      const src = scripts[i] && scripts[i].getAttribute('src') ? scripts[i].getAttribute('src') as string : '';
      if (src.indexOf('async-maps-drop-off') != -1) {
        scripts[i].parentNode!.removeChild(scripts[i]);
      }
    }
  }

  get selectedPoint(): string {
    return pickuppoint.selectedPoint.id;
  }

  get hasPlaceError(): boolean {
    return checkout.hasPlaceErrorByCode('pickuppoint_selection');
  }

  private toggleModal(direction: boolean) {
    direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId) ;
    if (direction) {
      pickuppoint.openMapClickBtn();
    }
  }
}
